<script>

  import Section from "../controls/Section.svelte";
  import TextField from "../controls/TextField.svelte";
  import Password from "../controls/TextFieldPassword.svelte";
  import Label from "../controls/LabelSetting.svelte";
  import ButtonDefault from "../controls/ButtonDefault.svelte";
  import MsgBoxOk from '../msgboxes/MsgBoxOk.svelte';

  let isShowMessageBoxToken = false;
  let isChangingPassword = false;
  let email = '';
  let password = '';
  let passwordConfirm = '';
  let accountId = '-';
  let isChanged = false;
  let token = '';

  function loadUserData() {
    fetch('https://www.deckblox.app/rest/user', {
      method: 'GET',
    })
    .then((response) => response.json())
    .then((data) => {
      email = data.email;
      password = '';
      accountId = data.id;
    })
    .catch((error) => console.error('Error loading user data:', error));
  }
  loadUserData();

  function handleInputChange(event) {
    if (event.target.name === 'email') {
      email = event.target.value;
    } else if (event.target.name === 'password') {
      password = event.target.value;
      isChangingPassword = true;
    } else if (event.target.name === 'passwordConfirm') {
      passwordConfirm = event.target.value;
    }
    
    isChanged = true;
  }

  function saveChanges() {
    const data = { id: accountId, emailAddress: email, password };
    const csrfToken = localStorage.getItem("csrfToken");
    console.log('csrf: ' + csrfToken);
    fetch('https://www.deckblox.app/rest/user', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': csrfToken,
      },
      body: JSON.stringify(data)
    })
    .then((response) => response.json())
    .then((data) => {
      console.log('User updated successfully:', data);
      isChanged = false;
    })
    .catch((error) => {
      console.error('Error updating user:', error);
      isChanged = false;
    });
    
  }

  function showMessageBoxToken() {
      isShowMessageBoxToken = true;
  }

  function handleMsgBoxClose() {
      isShowMessageBoxToken = false;
  }

  function onNewTokenRequest() {
      const data = { id: accountId, action: 'renewToken' };
      const csrfToken = localStorage.getItem("csrfToken");
      fetch('/rest/user', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': csrfToken,
        },
        body: JSON.stringify(data)
      })
      .then((response) => response.json())
      .then((data) => console.log('Token renewed successfully:', data))
      .catch((error) => console.error('Error renewing token:', error));
      
      showMessageBoxToken();
  }
</script>
  
<div class="space-y-8 text-left">
  <!-- Account ID Section -->
  <Section title="Account ID" subtitle="Your unique account identifier">
    <p>{'blx' + (91000 + accountId)}</p>
  </Section>

  <!-- Login Information Section -->
  <Section title="Login Information" subtitle="Manage your login credentials">
    <div class="space-y-4">
      <div class="flex items-center space-x-4">
          <Label text="Email Address"/>
          <TextField
              placeholder="Email Address"
              value={email}
              on:input={handleInputChange}
              autocomplete="off"
              name="email"
          />
      </div>
      <div class="flex items-center space-x-4">
          <Label text="Password"/>
          <Password
              placeholder="Password"
              showToggle={false}
              value={password}
              on:input={handleInputChange}
              autocomplete="new-password"
              name="password"
          />
      </div>

      {#if isChangingPassword}
        <div class="flex items-center space-x-4">
            <Label text="Password (Confirm)"/>
            <Password
                placeholder="Password (Confirm)"
                showToggle={false}
                value={passwordConfirm}
                on:input={handleInputChange}
                autocomplete="new-password"
                name="passwordConfirm"
            />
        </div>
      {/if}

      <div class="flex justify-end">
          <ButtonDefault
          text="Save Changes"
          isEnabled={isChanged}
          onClick={saveChanges}
          />
      </div>
      

    </div>
  </Section>
  
  <!-- Access Token Section -->
  <Section title="Access Token" subtitle="Request a token for secure API access">
    <p>Request a new token for access. Access Tokens are only visible when first created. </p>

    <div class="flex justify-end">
      <ButtonDefault
          text="Renew Token"
          isEnabled={true}
          onClick={onNewTokenRequest}
          />
    </div>
    

  </Section>
</div>
  

{#if isShowMessageBoxToken}
<MsgBoxOk
  title="Renew Token"
  message="The token is renewed. Please ensure that you have changed your token on all places where you use DeckBlox Games as the old token will no longer work. Copy this token and store is safely, you can not view this token again and need to request a new one if you have lost this token: {token}"
  onClose={handleMsgBoxClose}
/>
{/if}
  